import { get, getResultFromResponse, invoke, runAsyncSafe } from '@web3/utils';
import { EventBasedStore } from '../utils/EventBasedStore';
import { isBrowser } from '../utils/trick';

export type Permission = {
  ban_time: string;
  code: string;
  ip: string;
  is_login: number;
  is_trade: number;
  /** 0不可注册，1可以注册 */
  is_visible: 0 | 1;
  name_en: string;
};

type State = {
  loading: boolean;
  permission?: Permission;
};
const compute = (state: State) => {
  return {
    ipRestricted: state.permission && state.permission.is_visible !== 1,
    countryCode: state.permission?.code,
    // 荷兰法规限制
    isLawRestricted: isBrowser ? window.location.hostname.endsWith('.nl') : false,
  };
};
type ComputedState = ReturnType<typeof compute>;

export const permissionStore = new EventBasedStore<State, ComputedState>({ loading: true }, compute, async () => {
  const [, res] = await runAsyncSafe(getResultFromResponse(get<Permission>('/register/permission_v2')));
  permissionStore.setState({
    loading: false,
    permission: res || undefined,
  });
});

export const usePermission = () => {
  const state = permissionStore.useStoreState();
  return {
    ...state,
  };
};
